import { ExtraExpensesControllerFindAll$Params } from '@klubovna/api-client';
import { CreateExtraExpenseDto, ExtraIngredientExpense, UpdateExtraExpenseDto } from '@klubovna/api-client';
import { PaginatedResponse } from '@klubovna/api-client';
import { createAction, props } from '@ngrx/store';

export const ADMIN_EXTRA_EXPENSES_ID = '[Extra Expenses admin]';

export const loadExpenses = createAction(
  ADMIN_EXTRA_EXPENSES_ID + ' Load Expenses',
  props<{ params?: ExtraExpensesControllerFindAll$Params }>(),
);

export const loadExpensesSuccess = createAction(
  ADMIN_EXTRA_EXPENSES_ID + ' Load Expenses Success',
  props<{ response: PaginatedResponse<ExtraIngredientExpense> }>(),
);

export const loadExpensesFailure = createAction(
  ADMIN_EXTRA_EXPENSES_ID + ' Load Expenses Failure',
  props<{ error: string }>(),
);

export const createExpense = createAction(
  ADMIN_EXTRA_EXPENSES_ID + ' Create Expense',
  props<{ dto: CreateExtraExpenseDto }>(),
);

export const createExpenseSuccess = createAction(
  ADMIN_EXTRA_EXPENSES_ID + ' Create Expense Success',
  props<{ expense: ExtraIngredientExpense }>(),
);

export const createExpenseFailure = createAction(
  ADMIN_EXTRA_EXPENSES_ID + ' Create Expense Failure',
  props<{ error: string }>(),
);

export const updateExpense = createAction(
  ADMIN_EXTRA_EXPENSES_ID + ' Update Expense',
  props<{ id: string; dto: UpdateExtraExpenseDto }>(),
);

export const updateExpenseSuccess = createAction(
  ADMIN_EXTRA_EXPENSES_ID + ' Update Expense Success',
  props<{ expense: ExtraIngredientExpense }>(),
);

export const updateExpenseFailure = createAction(
  ADMIN_EXTRA_EXPENSES_ID + ' Update Expense Failure',
  props<{ error: string }>(),
);

export const deleteExpense = createAction(
  ADMIN_EXTRA_EXPENSES_ID + ' Delete Expense',
  props<{ id: string }>(),
);

export const deleteExpenseSuccess = createAction(
  ADMIN_EXTRA_EXPENSES_ID + ' Delete Expense Success',
  props<{ id: string }>(),
);

export const deleteExpenseFailure = createAction(
  ADMIN_EXTRA_EXPENSES_ID + ' Delete Expense Failure',
  props<{ error: string }>(),
);
